import AnimationManager from './AnimationManager'
import VueManager from './VueManager'

class Manager {

    constructor() {
        this._animationManager = new AnimationManager();
        this._vueManager = new VueManager();
        this.setupAnimations();
    }

    /**
     * The following block of code is used to automatically register Animations
     * in the AnimationManager. It will recursively scan this directory for
     * every Animation js file and automatically instantiate it and
     * adding it to the AnimationManager.
     *
     * Eg. ./Classes/Animation/Intro.js -> AnimationManager::get('intro')
     */
    setupAnimations() {
        const files = require.context('./Animation/', true, /\.js$/i)
        files.keys().map(key => {
            if( key.split('/').pop().split('.')[0] === 'Animation' ) return;

            this._animationManager.register( files(key).default.key(), files(key).default )
        } );
    }

    getAnimationManager() {
        return this._animationManager;
    }

    getVueManager() {
        return this._vueManager;
    }
}

export default new Manager();